export default {
  title: 'Tags',
  description: 'Gerencie as tags do seu blog.',
  labels: {
    new: 'Nova tag',
  },
  form: {
    title: 'Cadastro de tags'
  },
  fields: {
    tag: 'Tag',
    language: 'Idioma',
    url: 'URL',
    is_active: 'Ativo'
  },
  errors: {
    duplicateCompositeKey: 'Essa tag já está cadastrada para este site e idioma.'
  }
}
